import { JSX } from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    required,
    useRecordContext,
    SelectInput,
    ReferenceInput,
    TextField,
    DateField,
    useRedirect,
    useNotify,
    BooleanInput,
    Show,
    WithRecord,
    ImageInput, ImageField,
    Link
} from 'react-admin';
import {
    Grid,
    Stack,
    Box,
    Button
} from '@mui/material';


export const AdminAiSystemAgentToolEdit: () => JSX.Element = (): JSX.Element => {

    return (
        <>
            <Edit actions={false} redirect={ false }>
                <SimpleForm>
                    <Grid container spacing={ 2 } sx={ { width: '100%' } }>
                        <Grid size={ 6 }>
                            <Stack spacing={ 2 }>
                                <TextInput label="Operator Tool ID" name="operatorToolId" source="operatorToolId" />
                                <BooleanInput name="enabled" source="enabled" />
                                <TextInput name="name" source="name"/>
                            </Stack>
                        </Grid>
                        <Grid size={ 6 }>
                            <Stack spacing={ 2 }>
                                <TextInput
                                    multiline
                                    name="description"
                                    source="description"
                                    minRows={8}
                                    helperText={"Clear description of tool functionality"}
                                />
                            </Stack>
                        </Grid>
                        <Grid size={12}>
                            <TextInput
                                multiline
                                name="customParameters"
                                source="customParameters"
                                minRows={8}
                                helperText={"Custom Form JSON for Workflow node edit"}
                            />
                            <Link to="https://rjsf-team.github.io/react-jsonschema-form/docs/" target="_blank">JSON format reference</Link>
                        </Grid>
                        <Grid size={12}>
                            <ImageInput name="image" source="image" label="Icon" accept={{ 'image/*': ['.jpg', '.png', '.gif', '.jpeg'] }}>
                                <ImageField source="src" title="title" />
                            </ImageInput>
                        </Grid>
                    </Grid>
                </SimpleForm>
            </Edit>
        </>

    );

}